export const formNames = {
  SELF_SUPLY: 'selfSupply',
  SERVICE_PREPARATION_DELIVERY: 'servicePreparationDelivery',
  PAP_SERVICES_MANAGER: 'pap_services_manager',
  PLAN_LOGISTICS_PAP: 'plan_logistics_pap'
}
